
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
} from "recharts";

const CircularChart = (props) => {
  const { vital,color,height=400,width=400,size='medium' } = props;



  const data = [
    {
      name: "lower",
      value:
        vital?.normal_range?.lower_limit - vital?.allowed_range?.lower_limit,
      color: "#B33A3A",
    },
    {
      name: "normal",
      value:
        vital?.normal_range?.upper_limit - vital?.normal_range?.lower_limit,
      color: "#4BB543",
    },
    {
      name: "high",
      value:
        vital?.allowed_range?.upper_limit - vital?.normal_range?.upper_limit,
      color: "#B33A3A",
    },
  ];

  const IIR = (22.5/100)*height;
  const IOR = (30/100)*height;
  const OIR = (30.5/100)*height;
  const OOR = (31.5/100)*height;


  return (
    <>
      <div className={`box relative w-full ${size == 'medium' ? 'h-[250px]' : 'h-[175px]'}` }>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart width={width} height={height}>
            <Pie
              endAngle={-45}
              startAngle={230}
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={IIR}
              outerRadius={IOR}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Pie
              endAngle={-45}
              startAngle={230}
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={OIR}
              outerRadius={OOR}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div className="flex flex-col gap-1 justify-center items-center ">
            {size == 'medium' && <div className={`relative ${size == 'medium' ? 'w-9 h-9' : 'w-5 h-5'}  `}>
              <img
                src={vital?.icon_url}
                fill={true}
                alt={vital?.display_name}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 13vw"
              />
            </div>}
            <p
              style={{ color: color }}
              className={`font-semibold  ${size == 'medium' ? 'text-[48px]' : 'text-[22px]'}  `}
            >
              {vital.value}
            </p>
            <p
              style={{ color: color }}
              className={`font-regular  ${size == 'medium' ? 'text-[16px]' : 'text-[14px]'}  `}
            >
              {vital.unit}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CircularChart;
